import { __generator } from "tslib";
import { all, call, put, race, select, take, takeEvery, } from 'redux-saga/effects';
import { request } from '../../xhr/request';
import { groupJoinFail, groupJoinPending, groupJoinSuccess, groupLeaveFail, groupLeaveSuccess, requestJoinGroup, requestLeaveGroup, } from './actions';
import { addNotification } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications/redux/types';
import { confirmNo, confirmYes, pushGlobalConfirmationModal, pushModal, } from '../../Modals/redux/actionCreators';
import { getUserWatchState } from '../../WatchButton/redux/selectors';
import i18next from 'i18next';
import { userSchema } from '../normalizr/schemas/user';
import { normalize } from '../normalizr';
import { putEntities } from '../entities/actions';
import { ModalType } from '../../Modals/redux/types';
function handleClosedGroupJoinRequest(group) {
    var groupWatchState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getUserWatchState, group)];
            case 1:
                groupWatchState = _a.sent();
                if (!groupWatchState.isWatching) return [3 /*break*/, 3];
                return [4 /*yield*/, put(addNotification(NotificationType.Generic, {
                        message: i18next.t('group.join.errors.closed', {
                            groupname: group.username,
                        }),
                        isError: true,
                        cardProps: {
                            multiLine: true,
                            duration: 5000,
                        },
                    }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, put(pushModal(ModalType.GROUP_CLOSED_WATCH, {
                    params: { group: group },
                    wrapInModal: false,
                }))];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleGroupJoinRequest(_a) {
    var roleId, data, result, entities;
    var _b, _c, _d, _e, _f, _g;
    var group = _a.payload.group;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                if (!!((_d = (_c = (_b = group.extendedGroup) === null || _b === void 0 ? void 0 : _b.apps) === null || _c === void 0 ? void 0 : _c.join) === null || _d === void 0 ? void 0 : _d.canJoin)) return [3 /*break*/, 2];
                return [4 /*yield*/, call(handleClosedGroupJoinRequest, group)];
            case 1:
                _h.sent();
                return [2 /*return*/];
            case 2:
                roleId = (_f = (_e = group.extendedGroup) === null || _e === void 0 ? void 0 : _e.apps) === null || _f === void 0 ? void 0 : _f.join.intoRoleid;
                if (!roleId) {
                    return [2 /*return*/];
                }
                data = {
                    groupid: group.userId,
                    roleid: roleId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'group/join',
                        data: data,
                    })];
            case 3:
                result = _h.sent();
                if (!(!result || !result.success || !result.thisGroup)) return [3 /*break*/, 5];
                return [4 /*yield*/, all([
                        put(addNotification(NotificationType.Generic, {
                            message: result && result.errorDescription,
                            messageLocaleKey: result
                                ? "group.join.errors.".concat(result.errorDescription)
                                : 'group.join.errors.generic',
                            isError: true,
                            cardProps: {
                                multiLine: true,
                                duration: 5000,
                            },
                        })),
                        put(groupJoinFail(group, (result && result.errorDescription) ||
                            i18next.t('group.join.errors.generic'))),
                    ])];
            case 4:
                _h.sent();
                return [2 /*return*/];
            case 5:
                entities = normalize(result.thisGroup, userSchema).entities;
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 6:
                _h.sent();
                if (!((_g = result.thisGroup.extendedGroup) === null || _g === void 0 ? void 0 : _g.isIngroup)) return [3 /*break*/, 8];
                return [4 /*yield*/, put(groupJoinSuccess(result.thisGroup))];
            case 7:
                _h.sent();
                return [2 /*return*/];
            case 8: return [4 /*yield*/, all([
                    put(groupJoinPending(result.thisGroup)),
                    put(pushModal(ModalType.GROUP_JOIN_PENDING, {
                        params: { group: group },
                        wrapInModal: false,
                    })),
                ])];
            case 9:
                _h.sent();
                return [2 /*return*/];
        }
    });
}
function handleGroupLeaveRequest(_a) {
    var no, data, result, entities;
    var _b, _c;
    var group = _a.payload.group;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!!((_c = (_b = group.extendedGroup) === null || _b === void 0 ? void 0 : _b.apps) === null || _c === void 0 ? void 0 : _c.join.canLeave)) return [3 /*break*/, 2];
                return [4 /*yield*/, put(pushGlobalConfirmationModal({
                        confirmBtnLabelTransKey: 'group.leave.founder.button.accept',
                        textTransKey: 'group.leave.founder.error.body',
                        titleTransKey: 'group.leave.founder.error.heading',
                        confirmBtnType: 'danger',
                        translationOptions: { groupname: group.username },
                        withCancelButton: false,
                    }))];
            case 1:
                _d.sent();
                return [2 /*return*/];
            case 2: return [4 /*yield*/, put(pushGlobalConfirmationModal({
                    cancelBtnLabelTransKey: 'common.cancel',
                    confirmBtnLabelTransKey: 'group.leave.confirm.button.leave',
                    textTransKey: 'group.leave.confirm.body',
                    titleTransKey: 'group.leave.confirm.heading',
                    confirmBtnType: 'danger',
                    translationOptions: { groupname: group.username },
                }))];
            case 3:
                _d.sent();
                return [4 /*yield*/, race({
                        yes: take(confirmYes),
                        no: take(confirmNo),
                    })];
            case 4:
                no = (_d.sent()).no;
                if (no) {
                    return [2 /*return*/];
                }
                data = {
                    groupid: group.userId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'group/leave',
                        data: data,
                    })];
            case 5:
                result = _d.sent();
                if (!(!result || !result.success || !result.thisGroup)) return [3 /*break*/, 7];
                return [4 /*yield*/, all([
                        put(addNotification(NotificationType.Generic, {
                            message: result && result.errorDescription,
                            messageLocaleKey: result
                                ? "group.leave.errors.".concat(result.errorDescription)
                                : 'group.leave.errors.generic',
                            isError: true,
                            cardProps: {
                                multiLine: true,
                                duration: 5000,
                            },
                        })),
                        put(groupLeaveFail(group, (result && result.errorDescription) ||
                            i18next.t('group.leave.errors.generic'))),
                    ])];
            case 6:
                _d.sent();
                return [2 /*return*/];
            case 7:
                entities = normalize(result.thisGroup, userSchema).entities;
                return [4 /*yield*/, all([
                        put(putEntities({ entities: entities })),
                        put(groupLeaveSuccess(result.thisGroup)),
                    ])];
            case 8:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
export default function groupsSagaRoot() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(requestJoinGroup, handleGroupJoinRequest),
                    takeEvery(requestLeaveGroup, handleGroupLeaveRequest),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map